import styled from "styled-components";

// Style
export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  height: 58px;
  .img {
    border-radius: 50%;
    object-fit: cover;
  }
  .column-flex {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 80%;
  }
  .specialties {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 12px;
    font-weight: 400;
    color: rgba(117, 117, 117, 1);
    margin: 0 !important;
  }
  .name {
    font-size: 15px;
    font-weight: 500;
    color: rgba(65, 65, 65, 1);
    line-height: 36px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0 !important;
  }
`;

export const MainWrapper = styled.div`
  width: 100%;
  padding-bottom: 160px;
  .inner-links {
    width: 100%;
    height: auto;
    margin-top: 90px;
    border: 1px solid rgba(203, 203, 203, 1);
    border-radius: 12px;
    padding: 10px 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    column-gap: 36px;
    row-gap: 10px;
    flex-wrap: wrap;
    .label {
      color: rgba(33, 153, 232, 1);
      font-size: 12px;
      font-weight: 500;
      width: auto;
      padding: 0 !important;
      margin: 0 !important;
    }
  }
  .description {
    display: flex;
    flex-direction: column;
    gap: 32px;
    margin-top: 64px;
    h4,
    p {
      margin: 0 !important;
      padding: 0 !important;
    }
    h4 {
      margin-bottom: 10px !important;
      font-weight: 700;
      font-size: 18px;
      line-height: 36px;
      color: rgba(0, 0, 0, 1);
    }
    p {
      color: rgba(103, 103, 103, 1);
      font-weight: 500;
      font-size: 14px;
      line-height: 28px;
    }
  }
  .banner {
    width: 100%;
    margin: 16px 0; /* Increased margin for better UI breathing room */
    display: flex;
    justify-content: center;
    overflow: hidden; /* Prevents any accidental bleeding */

    .desktop-banner,
    .mobile-banner {
      display: block;
      width: 100%;
      height: auto;
      text-decoration: none;

      // This targets the Next.js Image component
      img,
      .img {
        width: 100% !important;
        height: auto !important;
        max-width: 100%;
        object-fit: contain; /* Ensures the whole banner is visible */
        display: block;
        border-radius: 12px; /* Optional: matches your page-title radius */
      }
    }

    @media (max-width: 900px) {
      margin: 8px 0;
    }
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 2%;
  margin: auto;
  margin-top: 30px;
  direction: ${(p) => p.webConfig.dir};
  @media (max-width: 900px) {
    flex-direction: column;
    margin-top: 90px;
  }
  .doctors-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 64%;
    gap: 50px;
    margin-top: 20px;
    @media (max-width: 900px) {
      width: 100%;
      margin-top: 0px;
    }
  }
  .pagination {
    background: rgba(255, 255, 255, 1);
    padding: 20px;
    border-radius: 20px;
    direction: ltr;
    @media (max-width: 538px) {
      padding: 10px;
    }
  }
  .Mui-selected {
    background: rgba(32, 183, 157, 1);
    color: rgba(255, 255, 255, 1);
  }
  .MuiPaginationItem-firstLast,
  .MuiPaginationItem-previousNext {
    transform: rotateY(180deg);
    color: rgba(0, 0, 0, 0.87);
    width: 40px;
    height: 40px;
  }
  .MuiPaginationItem-page {
    width: 40px;
    height: 40px;
    border-radius: 5px;
    font-weight: 400;
  }
  .bread-crumbs {
    width: 100%;
    margin-bottom: -40px;
  }
  .page-title {
    background-color: white;
    width: 100%;
    border-radius: 12px;
    padding: 13px 16px;
    font-weight: 600;
    font-size: 18px;
    margin-bottom: -30px;
    margin-top: 0;
    height: auto;
    line-height: 36px;
    @media (max-width: 700px) {
      font-size: 16px;
      line-height: 32px;
    }
  }
  .container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 24px;
    width: 100%;
  }
  .not-found {
    font-size: 24px;
    margin: auto;
    font-weight: 700;
    margin-top: 100px;
    @media (max-width: 600px) {
      font-size: 20px;
    }
  }
  .loading {
    margin: auto;
    height: 50px;
    margin-top: 100px;
  }
  .calendar-container {
    width: 100%;
    padding: 24px;
    background-color: white;
    border-radius: 16px;
  }
`;

export const DoctorCardWrapper = styled.div`
  background-color: white;
  border-radius: 16px;
  height: auto;
  width: 100%;
  padding: 24px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  @media (max-width: 900px) {
    flex-direction: column;
    padding: 16px;
  }
  .doctor-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: calc(100% - 80px);
    gap: 0;
    @media (max-width: 700px) {
      width: calc(100% - 65px);
    }
  }
  .column-flex {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin-top: -20px;
    width: 85%;
    @media (max-width: 1200px) {
      width: 80%;
    }
    @media (max-width: 900px) {
      width: 100%;
    }
  }
  .row-flex {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
    h2,
    h3,
    h4,
    h5 {
      margin: 0 !important;
      padding: 0 !important;
    }
    @media (max-width: 700px) {
      align-items: flex-start;
      gap: 12px;
    }
  }
  .header {
    @media (max-width: 700px) {
      align-items: center;
    }
  }
  .img-container {
    width: 80px;
    height: 80px;
    @media (max-width: 700px) {
      width: 65px;
      height: 65px;
    }
  }
  .name {
    font-size: 16px;
    font-weight: 600;
    color: rgba(65, 65, 65, 1);
    line-height: 36px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    @media (max-width: 700px) {
      font-size: 15px;
    }
  }
  .img {
    border-radius: 50%;
    object-fit: cover;
  }
  .label {
    color: rgba(65, 65, 65, 1);
    font-size: 14px;
    font-weight: 600;
    @media (max-width: 700px) {
      margin-top: 4px;
    }
  }
  .address-container {
    width: 60%;
    @media (min-width: 901px) and (max-width: 1108px) {
      width: 100%;
    }
    @media (max-width: 700px) {
      width: 100%;
      gap: 2px !important;
    }
  }
  .buttons {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    width: 40%;
    @media (min-width: 901px) and (max-width: 1108px) {
      width: 100%;
    }
    @media (max-width: 700px) {
      width: 100%;
      flex-direction: column;
    }
  }
  .specialties,
  .services,
  .address {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    font-weight: 400;
    color: rgba(117, 117, 117, 1);
    margin: 0;
  }
  .services,
  .address {
    @media (max-width: 700px) {
      -webkit-line-clamp: 2;
      line-height: 28px;
    }
  }
  .services {
    color: rgba(126, 126, 126, 1);
  }
  .gap-6 {
    gap: 6px;
  }
  .line {
    display: block;
    width: 100%;
    height: 1px;
    background: rgba(203, 203, 203, 1);
    margin: 12px 0;
    @media (max-width: 700px) {
      margin: 10px 0;
    }
  }
  .icon {
    width: 20px;
    height: 20px;
    color: rgba(249, 249, 249, 1);
  }
  .gap-12 {
    gap: 12px;
  }
  .gap-10 {
    gap: 10px;
  }
  .view-button {
    border: 1px solid rgba(18, 18, 18, 1);
    background-color: transparent;
    color: rgba(18, 18, 18, 1);
  }
  .book {
    border: 1px solid rgba(69, 144, 144, 1);
    background-color: rgba(69, 144, 144, 1);
    color: rgba(249, 249, 249, 1);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 5px;
    cursor: pointer;
  }
  .button {
    text-align: center;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    height: 42px;
    width: 50%;
    line-height: 42px;
    @media (max-width: 700px) {
      width: 100%;
    }
  }
  .address {
    width: calc(100% - 60px);
    @media (max-width: 700px) {
      font-size: 12px;
      line-height: 24px;
    }
  }
  .footer {
    justify-content: flex-end !important;
    @media (min-width: 901px) and (max-width: 1108px) {
      flex-direction: column;
    }
    @media (max-width: 700px) {
      flex-direction: column;
    }
  }
  .address-label {
    @media (max-width: 700px) {
      font-size: 12px;
      font-weight: 600;
      margin-top: 0;
    }
  }
  .location {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 5px;
    width: 60px;
    @media (max-width: 700px) {
      margin-top: 3px;
    }
  }
  .width-100 {
    width: 100%;
  }
`;

export const FilteringWrapper = styled.div`
  background: white;
  border-radius: 16px;
  height: auto;
  width: 34%;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  margin-top: 20px;
  @media (max-width: 900px) {
    display: none;
  }
`;
export const FilteringMobileWrapper = styled.div`
  background-color: white;
  padding: 10px;
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  padding-bottom: 100px;
  .fixed-button {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: white;
    padding: 10px 16px;
    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.2);
    .button {
      width: 100%;
    }
  }
`;

export const MobileHeaderWrapper = styled.div`
  background-color: white;
  position: fixed;
  z-index: 999;
  top: 57px;
  left: 0;
  padding: 16px;
  padding-top: 5px;
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  @media (min-width: 901px) {
    display: none;
  }
  .input {
    width: 50%;
    height: 48px;
  }
  .red-circle {
    display: block;
    width: 5px;
    height: 5px;
    background-color: red;
    border-radius: 50%;
  }
  .filters {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 5px;
    width: 50%;
    height: 47px;
    background: #f4f4f4;
    border-radius: 10px;
    color: #0d2439;
    font-size: 15px;
    cursor: pointer;
    border: 1px solid #e5e7eb;
  }
  .icon {
    width: 18px;
    height: 18px;
    color: #0d2439;
  }
`;
